import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { LayoutComponent } from './components/layout/layout.component';
import { AuthGuard } from './components/auth/auth.guard';
import { LoginGuard } from './guards/login.guard';
import { AgentLayoutComponent } from './components/core/agent/agent-layout/agent-layout.component';
import { SettingsComponent } from './components/settings/settings.component';
import { SupervisorLayoutComponent } from './components/supervisor/supervisor-layout/supervisor-layout.component';
import { CampaignViewComponent } from './components/supervisor/campaign-view/campaign-view.component';
import { AgentMetricsComponent } from './components/agent/agent-metrics/agent-metrics.component';
import { RoleGuard } from './guards/role.guard';
import { statusAgentsResolver } from './resolvers/status-agents.resolver';
import { WorkspaceSelectionComponent } from './components/workspace-selection/workspace-selection.component';
import { workspaceResolver } from './components/auth/workspace-resolver';

export const routes: Routes = [
  {
    path: 'agent-layout',
    component: AgentLayoutComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['agent', 'supervisor', 'admin', 'superadmin'] },
    resolve: { statusAgent: statusAgentsResolver }
  },
  {
    path: 'agent-metrics',
    component: AgentMetricsComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['agent', 'supervisor', 'admin', 'superadmin'] }
  },
  {
    path: 'supervisor',
    component: SupervisorLayoutComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['admin', 'supervisor', 'superadmin'] }
  },
  {
    path: 'campaign/:id',
    component: CampaignViewComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['admin', 'supervisor', 'superadmin'] }
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['agent', 'admin', 'supervisor', 'superadmin'] }
  },
  {
    path: 'layout',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    resolve: {
      platform: workspaceResolver,
    }
  },
  {
    path: 'workspace-selection',
    title: 'Workspace selection',
    canActivate: [AuthGuard, RoleGuard],
    component: WorkspaceSelectionComponent,
    resolve: {
      platform: workspaceResolver,
    }
  },
  // Login route - prevent access when already authenticated
  // Root path redirects to login
  {
    path: '',
    component: LoginComponent,
    canActivate: [LoginGuard],
    title: 'Login'
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginGuard],
    title: 'Login'
  },
  {
    path: 'otp-auth',
    loadComponent: () => import('./components/auth/otp-auth/otp.component').then(m => m.OtpComponent),
    title: 'OTP Verification'
  },
  { path: '', pathMatch: 'full', redirectTo: '' },
  { path: '**', title: 'Not found', redirectTo: '' },
];
